<template>
  <button class="itinerary-item" v-on="$listeners" v-bind="$attrs" :class="{loading: isLoading}">
    <div class="overviewImage">
      <img :src="img" />
    </div>
    <div class="info">
      <div class="type" :class="{primary: !isPlannerScheduled, recommended: isPlannerScheduled}">{{ stayText }}</div>
      <div class="name">
        <b>{{ name }}</b>
      </div>
    </div>
  </button>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
import {useStay} from '../../solution-views/stay';

Vue.use(VueCompositionAPI);

export default {
  props: {
    isLoading: Boolean,
  },
  setup() {
    const {stayActivity} = useStay();

    const isPlannerScheduled = computed(() => {
      return stayActivity.value?.spec?.curated;
    });

    const stayText = computed(() => {
      return isPlannerScheduled.value ? 'Recommended Stay' : 'Selected Stay';
    });

    const img = computed(() => {
      return stayActivity.value?.images?.small;
    });

    const name = computed(() => {
      return stayActivity.value?.name;
    });

    return {
      img,
      name,
      stayText,
      isPlannerScheduled,
    };
  },
};
</script>

<style scoped>
.itinerary-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-top: 0px;
  min-height: 38px;
  /* margin-left: -4px; */
  transition: 0.3s ease background;
  position: relative;
  border: none;
  appearance: none;
  color: var(--toneTDark);
  background: transparent;
  width: 100%;
  padding: 5px 0 5px 4px;
  background: #fff;
}

.itinerary-item:hover {
  background-color: var(--toneBw-3);
}
.itinerary-item:hover::after {
  opacity: 1;
}

.itinerary-item::after {
  content: '';
  position: absolute;
  right: 0;
  width: 40px;
  height: 40px;
  background-size: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(./icon-filter-downarrow.svg);
  transform: rotate(-90deg);
  top: 50%;
  margin-top: -20px;
  opacity: 0.5;
  transition: 0.5s ease opacity;
}

.overviewImage {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  position: relative;
}

.overviewImage img {
  width: 100%;
  height: 100%;
  border-radius: var(--radiusSmall);
  box-sizing: border-box;
  background-color: var(--toneBw-0);
  object-fit: cover;
}

.info {
  padding: 0px 20px 0 10px;
  box-sizing: border-box;
  text-align: left;
  align-self: flex-start;
  flex: 1;
  overflow: hidden;
  padding-right: 40px;
}

.type {
  margin-top: 5px;
  font-size: var(--tSize-xs);
  font-weight: bold;
}

.name {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--tSize-sm);
  color: var(--toneDark-100);
}

.loading.itinerary-item {
  pointer-events: none;
}

.loading .overviewImage,
.loading .type,
.loading .name {
  border-radius: var(--radiusSmall);
  background: rgba(228, 229, 232, 0.5);
  font-size: 0;
}

.loading .name,
.loading .type {
  height: 11px;
  width: 80%;
}

.loading .type {
  margin-bottom: 5px;
  width: 60%;
}

.recommended {
  color: var(--toneSecondary-100);
}

.primary {
  color: var(--tonePrimary-100);
}
</style>
